import React, { useEffect, useState } from 'react';
import './MLogin.css';

import {TailSpin} from 'react-loader-spinner';
import * as Loader from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import {loadStripe} from '@stripe/stripe-js';

import MapItButton from '../../Common/MapItButton/MapItButton';
import * as Network from '../../Network/Network';
import User from "../../../Models/User";
import eye_crossed from "../../../Assets/eye_icon_crossed.png";
import eye_icon from "../../../Assets/eye_icon.png";

import PageTitle from '../../Common/PageTitle/PageTitle'; // Adjust the path as per your file structure
import {Helmet} from "react-helmet";

const prod_host = "https://server.mapit.cc";

const MLogin = ({setUser, 
  setExProj, 
  setAppState, 
  regMode, 
  setRegMode, 
  subPlan, 
  fpObj, 
  address,
  email, 
  setEmail}) => {
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [wrongCredentials, setWrongCredentials] = useState(false);
  const [maskText, setMaskText] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [passIncorrect, setPassIncorrect] = useState(false);

  let navigate = useNavigate();

  const welcomeTitle = regMode?"Get Started":"Welcome Back";
  const welcomeMsg = regMode?"Welcome to MapIt - Let's create your account":"Enter your email and password to access your account";
  const accountQuestion = regMode?"Already have an account?":"Don't have an account?";
  const accountLink = regMode?"Log In":"Sign Up";
  // const stripeProductKey = "pk_test_51P7G7WAAPuhdwRL35ymriOpqNPcTQy2S8cW7jxv4dVY1lgHBnatmUk3a9RgvQcQ5Z5xIbzB8Lf6VajWl6NGNE5ZQ00QQG5q47y";
  const stripeProductKey = "pk_live_51P7G7WAAPuhdwRL3ItOHsgW1Ds2UmF7bYPmECSg1tg125aqxvrweluh30wcmAfUaoHQ2HsefcdkndXb1oYBTeKXF00qmntGvir";
  // move stripe product to environment variable - todo

  // useEffect(() =>  {
  //   localStorage.setItem("user", JSON.stringify(user));
  // }, [user]);

  const onSignUp = () => {
    console.log('in register function');
    console.log(email);
    console.log(password);
    setLoading(true);
    fetch(`${prod_host}/register`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        email: email,
        first_name: firstName,
        last_name: lastName,
        profession: "",
        password: password
      })
      })
      .then(response => response.json())
      .then(serverData => {
        console.log(serverData);
        if(serverData.newUser.email) {
          let userData = serverData.newUser;
          let ex_proj = serverData.exProj;
          fetch(`${prod_host}/emailVal`, {
            method: 'post',
            headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${userData.accessToken}`},
            body: JSON.stringify({
              email: email
            })
          })
          .then(response => response.json())
          .then(emailConfirmation => {
            if(emailConfirmation === "success") {
              let newUser = new User(userData.email,
                userData.first_name,
                userData.last_name,
                userData.profession,
                {},
                userData.accessToken, 
                userData.refreshToken);
                if (userData.projects && Object.keys(userData.projects).length) {
                  newUser.projects = userData.projects;
                  console.log(`new user after login: ${newUser}`);
                  console.log(newUser);
                }
                setUser(newUser);
                localStorage.setItem("aToken", newUser.accessToken);
                localStorage.setItem("rToken", newUser.refreshToken);
              if (subPlan === 0) {
                setLoading(false);
                navigate("/projectview");
              } else {
                // user is signing up and has selected a subscription plan
                // 1. send request to stripe endpoint to create a payment screen
                Network.stripeCheckoutSession (userData.email, subPlan, fpObj, address, async function (err, session) {
                  if (err) {
                    console.log("error during sub upgrade");
                    console.log(err);
                    setLoading(false);
                  } else {
                    const stripe = await loadStripe(stripeProductKey);
                    if(session && session.id) {
                      const result = stripe.redirectToCheckout ({
                        sessionId: session.id
                      });
                    }
                    setLoading(false);
                  }
                });
              }
            } else {
              console.log("email confirmation return but not successful");
              console.log(emailConfirmation);
              setLoading(false);
            }
          })
          .catch ((error) => {
            console.log(`error occurred from server fduring email validation`);
            console.log(error);
            setLoading(false);
          });
        } else {
          console.log("user data returned but not the correct data");
          console.log(serverData);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(`error occurred from server during sign up`)
        console.log(error);
        setLoading(false);
      });
  }

  const onLogin = () => {
    console.log('in login function');
    console.log(email);
    console.log(password);
    setLoading(true);
    fetch(`${prod_host}/login`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        email: email,
        password: password
      })
      })
      .then(response => response.json())
      .then(userData => {
        if (userData.returnUser.email) {
          console.log(`Debug Log: Data returned from login api call: ${userData}`);
          console.log(userData);
          let user_data = userData.returnUser;
          let newUser = new User(user_data.email, 
            user_data.first_name, 
            user_data.last_name, 
            user_data.profession, 
            {}, user_data.accessToken, 
            user_data.refreshToken, 
            user_data.last_updated,
            (user_data.sub_plan?user_data.sub_plan:0),
            user_data.sub_cancel_pending.substring(0,10));
          if (user_data.projects && Object.keys(user_data.projects).length) {
            newUser.projects = user_data.projects;
            console.log(`new user after login: ${newUser}`);
            console.log(newUser);
            // fetch(`${prod_host}/floorplan-snapshots-stickynotes/${Object.keys(user_data.projects)[0]}`, {
            //   method: 'get',
            //   headers: {
            //    Accept: 'application/json',
            //   'Content-Type': 'application/json',
            //   'authorization': `Bearer ${user_data.accessToken}`
            //   }
            // })
            // .then(response => response.json())
            // .then(floorplans => {
            //   console.log(`Debug Log: Return from getSnapshots endpoint ${floorplans}`);
            //   console.log(floorplans);
            //   let curProj = Object.keys(newUser.projects)[0]
            //   let curSnapshots = floorplans[Object.keys(floorplans)[0]].snapshots;
            //   newUser.projects[curProj].floorplans[Object.keys(newUser.projects[curProj].floorplans)[0]].snapshots = curSnapshots;
            //   console.log(`New user after setting snapshots`);
            //   console.log(newUser);
            // })
            // .catch((error) => {
            //   console.log(`Exception occurred while getting snapshots`);
            //   console.log(error);
            // })
          }
          setUser(newUser);
          localStorage.setItem("aToken", newUser.accessToken);
          localStorage.setItem("rToken", newUser.refreshToken);
          if (subPlan === 0 || newUser.sub_plan === 1) {
            setLoading(false);
            navigate("/projectview");
          } else {
            Network.stripeCheckoutSession (user_data.email, subPlan, fpObj, address, async function (err, session) {
              if (err) {
                console.log("error during sub upgrade");
                console.log(err);
                setLoading(false);
              } else {
                const stripe = await loadStripe(stripeProductKey);
                if(session && session.id) {
                  const result = stripe.redirectToCheckout ({
                    sessionId: session.id
                  });
                }
                setLoading(false);
              }
            });
          }
        } else {
          console.log(`Debug Log: Error occurred during login: ${userData}`);
          console.log(userData);
          setLoading(false);
          setPassIncorrect(true);
        }
      })
      .catch((error) => {
        console.log(`error occurred from server`)
        console.log(error);
        setLoading(false);
        setPassIncorrect(true);
      });
  }

  const onFirstNameChange = (fName) => {
    setFirstName(fName.target.value);
  }

  const onLastNameChange = (lName) => {
    setLastName(lName.target.value);
  }
  
  const onEmailChange = (email) => {
    // check input before setting
    setEmail(email.target.value);
  }

  const onPasswordChange = (password) => {
    // check input before setting
    setPassword(password.target.value);
  }

  const onForgotPassword = () => {
    navigate("/forgot-password")
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      regMode?onSignUp():onLogin ()
    }
  }

  return (
    <div className='mcontainer'>
      <PageTitle title="MapIt Login"/>
      <Helmet>
      <meta charSet="utf-8" />
      <link rel="canonical" href="https://mapit.cc/login" />
      <title>MapIt Login</title>
      </Helmet>
      <div className="mcontainer-right">
        <div className="login-container">
          <div className="login-text">
            <p className="login-text-welcome">{welcomeTitle}</p>
            <p className="login-text-message">{welcomeMsg}</p>
          </div>
          { regMode &&
          <div className='mname-input-div'>
            <div className='mfirst-name-input-div'>
              <input
                type="text"
                className="mfirst-name-input"
                placeholder={"Frist Name"}
                onChange={onFirstNameChange}
                selectionColor={'#34666F'}
                keyboardType={'email-address'}
              />
            </div>
            <div className='mlast-name-input-div'>
              <input
                type="text"
                className="mfirst-name-input"
                placeholder={"Last Name"}
                onChange={onLastNameChange}
                selectionColor={'#34666F'}
                keyboardType={'email-address'}
              />
            </div>
          </div>
          }
          <div className='memail-input-div'>
            <input
              type="email"
              className="memail-input-login"
              placeholder={"Email"}
              value={email}
              onChange={onEmailChange}
              selectionColor={'#34666F'}
              keyboardType={'email-address'}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className='mpassword-input-div'>
            <input
              type={maskText?"password":"text"}
              className="mpassword-secure"
              placeholder={"Password"}
              onChange={onPasswordChange}
              selectionColor={'#34666F'}
              onKeyDown={handleKeyDown}
            />
            <img
              className="password-input-icon"
              onClick={() => setMaskText(!maskText)}
              src={maskText ? eye_crossed:eye_icon}
              alt="Contact MapIt support center" 
              width="22.05"
              height="15.75"
            />
          </div>
          {!regMode &&
            <div className='mforgot-pass-div'>
              <p className='forgot-pass-p' onClick={() => onForgotPassword()}>Forgot Password?</p>
            </div>
          }
          <div className="login-button-div">
            <MapItButton onSubmit={regMode?onSignUp:onLogin} className="mlogin-mapitButton" text={regMode?"Sign Up":"Sign In"}></MapItButton>
          </div>
          {passIncorrect && 
          <div className="login-error-div">
              <p className="login-error-msg">Sorry your email or password is incorrect. Please try again.</p>
          </div>
        }
        </div>
        <div className='signup-text-div'>
            <p className="no-account-p">{accountQuestion}</p>
            <p className="signup-p" onClick={() => setRegMode(!regMode)}>{accountLink}</p>
        </div>
        { loading &&
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
      }
      </div>
    </div>
  );
}

export default MLogin;